import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router';

import {
  Chip,
  IconButton,
  Menu,
  MenuItem,
  Snackbar,
  Typography,
} from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';

import {
  Close as CloseIcon,
  FlashOn as ExecutionIcon,
} from '@material-ui/icons';

import { CopyToClipboard } from 'react-copy-to-clipboard';

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: '8px',
    whiteSpace: 'normal',
    height: 'auto',
  },
  label: {
    paddingTop: '4px',
    paddingBottom: '4px',
    width: 'calc(100% - 58px)',
    whiteSpace: 'normal',
  },
  info: {
    display: 'flex',
    flexFlow: 'column',
  },
  name: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  description: {
  },
  typography: {
  }
}));

export default function ExecutionChip(props) {
  const { value, maxWidth } = props;
  const classes = useStyles();

  const [menuAnchor, setMenuAnchor] = React.useState(null);
  const [actionMessage, setActionMessage] = React.useState("");
  const [executionRedirect, setExecutionRedirect] = React.useState(null);
  const execution=value;

  const handleClick = (event) => {
    setMenuAnchor(event.currentTarget);
  };
    
  const handleNav = () => {
    setExecutionRedirect(execution.ExecutionId);
  };

  const handleCloseMenu = () => {
    setMenuAnchor(null);
  };

  const handleActionPerformed = (message) => {
    setActionMessage(message);
    handleCloseMenu();
  };

  const clearActionMessage = () => {
    setActionMessage("");
  };
  
  if(!execution) {
      return(null);
  }
  
  if(executionRedirect) {
    return <Redirect push to={`/Executions/${executionRedirect}`} />;  
  }

  return (
    <React.Fragment>
      <Chip
        classes={{ root: classes.root, label: classes.label }}
        variant="outlined"
        icon=<ExecutionIcon/>
        label={
          <div className={classes.info}>
            <div className={classes.name}>
              <Typography className={classes.typography} variant='inherit' color='primary'>
                {execution.ExecutionId}
              </Typography>
            </div>
            <div className={classes.description}>
              <Typography className={classes.typography} variant='inherit' >
                {execution.Description}
              </Typography>
            </div>
          </div>
        }
        onClick={handleClick}
        style={{ maxWidth }}
      />
      <Menu
        id="action-menu"
        anchorEl={menuAnchor}
        keepMounted
        open={Boolean(menuAnchor)}
        onClose={handleCloseMenu}
      >
        <CopyToClipboard 
            text={execution.ExecutionId} 
            onCopy={() => handleActionPerformed('Execution ID copied to clipboard')}>
          <MenuItem>Copy execution ID</MenuItem>
        </CopyToClipboard>
        <MenuItem onClick={handleNav}>Go to execution...</MenuItem>
      </Menu>
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        open={actionMessage.length>0}
        autoHideDuration={3000}
        onClose={clearActionMessage}
        message={actionMessage}
        action={
          <IconButton size="small" aria-label="close" color="inherit" onClick={clearActionMessage}>
            <CloseIcon fontSize="small" />
          </IconButton>
        }
      />
    </React.Fragment>
  );
}

ExecutionChip.propTypes = {
  value: PropTypes.object.isRequired,
  maxWidth: PropTypes.string,
};

ExecutionChip.defaultProps = {
};

